import Request from "@/libraries/request.js";
import Const from "@/const/const.js";

export default {
  BaseURL: "/config",
  async get(url = null) {
    const configsReply = await Request.getAsync(url);
    let configs = {};
    if (configsReply.data.status) {
      configs = configsReply.data.data;
    }
    return configs;
  },
  async get_config(config = null) {
    const url = (config != null) ? this.BaseURL + "/" + config : this.BaseURL;
    const data = await this.get(url);
    return data;
  }
};




// WEBPACK FOOTER //
// ./src/model/config_model.js